import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { JwtModule } from '@auth0/angular-jwt';
import { LoginComponent } from './login.component';
import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  declarations: [
    LoginComponent
  ],
  exports:      [ LoginComponent ],
  providers:    [ 
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ]
})

export class LoginModule { }
